import { render, staticRenderFns } from "./Pendahuluan.vue?vue&type=template&id=214c5bb5&"
import script from "./Pendahuluan.vue?vue&type=script&lang=js&"
export * from "./Pendahuluan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports